// Central place for public-facing site facts. Production domain is careerova.tech.
export const SITE_URL = 'https://careerova.tech';
export const SUPPORT_EMAIL = 'support@careerova.tech';
export const BRAND = 'Careerova';
export const LEGAL_ENTITY = 'Careerova Technologies LLP';
